"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLayoutContext = exports.LayoutContextProvider = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
const layoutContextDefaultControlHeight = 40;

/**
 * This Context's purpose is to sync layout across the various components in the Select/MultiSelect
 * components. Since we are using react-select, we sometimes need to go around the react-select
 * API. Things included in this context are shared parameters that should cause a re-render of the
 * component when they change.
 *
 * Note: we DON'T expose this directly on purpose to ensure the consumer always uses the
 * `LayoutContextProvider` which wraps up some functionality that's required to make this
 * all work properly.
 */
const LayoutContext = (0, _lodestarUtils.createContext)({
  controlHeight: layoutContextDefaultControlHeight,
  setControlHeight: () => undefined
}, "LayoutContext");
const useLayoutContext = () => {
  return (0, _react.useContext)(LayoutContext);
};
exports.useLayoutContext = useLayoutContext;
const LayoutContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [controlHeight, setControlHeight] = (0, _react.useState)(layoutContextDefaultControlHeight);
  const layoutCtxValue = (0, _react.useMemo)(() => ({
    controlHeight,
    setControlHeight
  }), [controlHeight]);
  return /*#__PURE__*/_react.default.createElement(LayoutContext.Provider, {
    value: layoutCtxValue
  }, children);
};
exports.LayoutContextProvider = LayoutContextProvider;
//# sourceMappingURL=LayoutContext.js.map